// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "@sentry/react";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../domain/store/FareEstimateStoreV1.mjs";

var fare_cash_icon = {
  src: AssetStore$PorterinFeature.paymentCash,
  width: 28.0,
  height: 28.0,
  alt: "Payment Cash Icon"
};

var address_drop_icon = {
  src: AssetStore$PorterinFeature.dropPin,
  width: 12.0,
  height: 15.0,
  alt: "Drop Address Icon"
};

var default_vehicle_v2 = {
  path: AssetStore$PorterinFeature.defaultTruckIcon,
  alt_text: "Default Vehicle Icon v2"
};

var location_pin = {
  src: AssetStore$PorterinFeature.mapPin,
  width: 24.0,
  height: 24.0,
  alt: "Map Pin"
};

var offers = {
  src: AssetStore$PorterinFeature.offersIcon,
  width: 20.0,
  height: 20.0,
  alt: "Offers Icon"
};

var arrow_right = {
  src: FareEstimateStoreV1$PorterinFeature.arrowRightIcon,
  width: 20.0,
  height: 15.0,
  alt: FareEstimateStoreV1$PorterinFeature.arrowRightAlt
};

var shop_icon = {
  src: FareEstimateStoreV1$PorterinFeature.shopIcon,
  width: 60.0,
  height: 60.0,
  alt: FareEstimateStoreV1$PorterinFeature.shopIconAlt
};

var error_query_params = {
  text: FareEstimateStoreV1$PorterinFeature.error_query_params_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_query_params_sub_text
};

var error_not_authenticated = {
  text: FareEstimateStoreV1$PorterinFeature.error_not_authenticated_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_not_authenticated_sub_text
};

var error_something_wrong = {
  text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_sub_text
};

var error_unserviceable_pickup = {
  text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_sub_text_pickup
};

var error_unserviceable_dropoff = {
  text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_sub_text_dropoff
};

var error_unserviceable = {
  text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_unserviceable_sub_text
};

function authPrefill(query_params) {
  return {
          mobile: query_params.customer_mobile,
          name: query_params.customer_name,
          requirement_type: query_params.frequency
        };
}

function vehicleFareVm(vehicle, related_icon) {
  return {
          vehicle_id: vehicle.vehicle_id,
          name: vehicle.name,
          capacity: vehicle.capacity_display,
          fare: vehicle.base_fare,
          discount: undefined,
          gold_discount: undefined,
          without_discount: undefined,
          dimensions: undefined,
          eta: undefined,
          image: related_icon !== undefined ? related_icon.vehicle_image : (React.captureMessage("Fare Estimate - Icon not found for vehicle_id  " + String(vehicle.vehicle_id) + ""), default_vehicle_v2),
          selected_image: related_icon !== undefined ? related_icon.vehicle_image : default_vehicle_v2,
          fare_breakup: undefined
        };
}

var commonAssetPath = "/assets/icons/common/booking-flow/";

var etaPillOptions = {
  loop: true,
  autoplay: true,
  path: "https://nest-platform-assets.porter.in/Eta_Pill_4366b62ba0/Eta_Pill_4366b62ba0.json",
  rendererSettings: undefined
};

var default_vehicle_icon = {
  src: "/images/fare-estimate-result/default-truck-icon.svg",
  width: 54.0,
  height: 54.0,
  alt: "Default Vehicle Icon"
};

var new_default_vehicle_icon = {
  src: "/images/fare-estimate-result/default-truck-icon.svg",
  width: 54.2,
  height: 34.8,
  alt: "Default Vehicle Icon"
};

var error_something_went_wrong = {
  src: "https://nest-platform-assets.porter.in/error_ef88199d3d/error_ef88199d3d.svg",
  width: 150.0,
  height: 150.0,
  alt: "Map Pin"
};

var error_invalid_location = {
  src: "https://nest-platform-assets.porter.in/unserviceable_61cacbbd74/unserviceable_61cacbbd74.svg",
  width: 158.0,
  height: 158.0,
  alt: "Map Pin"
};

export {
  commonAssetPath ,
  etaPillOptions ,
  fare_cash_icon ,
  address_drop_icon ,
  default_vehicle_icon ,
  new_default_vehicle_icon ,
  default_vehicle_v2 ,
  location_pin ,
  error_something_went_wrong ,
  error_invalid_location ,
  offers ,
  arrow_right ,
  shop_icon ,
  error_query_params ,
  error_not_authenticated ,
  error_something_wrong ,
  error_unserviceable_pickup ,
  error_unserviceable_dropoff ,
  error_unserviceable ,
  authPrefill ,
  vehicleFareVm ,
}
/* @sentry/react Not a pure module */
